import React, { useState } from "react";
import { Button } from "../../../../../Components/Helper";
import Popup from "../../../../../ReusableFunctions/Popup";
import Modal from "../../../../../ReusableComponents/Modal";
import InputField from "../../../../../ReusableComponents/InputField";
import Form from "../../../../../ReusableComponents/Form";
import { taxPercentageValidation } from "../../../../../utils/inputValidations";
import Loading from "../../../../../ReusableFunctions/Loader";
import { updateDspTax } from "../../../../../apis/users";

const EditTaxPercentage = ({ open, onClose, dsp, onUserUpdate }) => {
  const [isTaxNotApplicable, setIsTaxNotApplicable] = useState(
    dsp?.is_tax_applicable === false ? true : false,
  );
  const [taxValue, setTaxValue] = useState(dsp?.tax || "");
  const EditTax = async (dspDetails) => {
    try {
      Loading.set(true);
      const res = await updateDspTax(dspDetails);
      onUserUpdate(res?.updatedDSP);
      Loading.set(false);
      Popup.alert("SUCCESS", "Tax Percentage Updated", "SUCCESS", onClose);
    } catch (e) {
      Loading.set(false);
      Popup.alert("Error", e || "something went wrong.", "ERROR");
    }
  };

  return (
    <Modal
      header={"Tax Percentage"}
      open={open}
      onClose={onClose}
      contentStyle={{ width: "574px", height: "auto" }}
      divider={true}
      headingStyle={{ fontSize: "18px" }}
      iconSize={"18px"}
      headerContainerStyle={{ padding: "20px 40px" }}
    >
      <Form
        onSubmitForm={(data) => {
          if (isTaxNotApplicable) {
            // Validation bypass — directly call
            EditTax({
              tax: 0,
              is_tax_applicable: false,
              id: dsp.id,
            });
          } else {
            const { tax } = data;
            EditTax({
              tax,
              is_tax_applicable: true,
              id: dsp.id,
            });
          }
        }}
        style={{
          padding: "15px 40px 20px",
          display: "flex",
          flexDirection: "column",
          gap: "1.1rem",
        }}
      >
        {(onSubmit) => (
          <>
            <InputField
              key={isTaxNotApplicable ? "disabled" : "enabled"}
              label={"Tax Percentage (%)"}
              name={"tax"}
              placeholder={"Enter Tax Percentage"}
              required={false}
              disabled={isTaxNotApplicable}
              type="number"
              min={0}
              max={100}
              style={{
                height: "51px",
                borderRadius: "8px",
                padding: "2px 15px",
                background: isTaxNotApplicable ? "#f3f3f3" : "#fff",
              }}
              inputStyle={{
                fontSize: "16px",
                opacity: isTaxNotApplicable ? 0.5 : 1,
              }}
              validation={
                isTaxNotApplicable ? undefined : taxPercentageValidation
              }
              labelStyle={{
                paddingBottom: "7px",
                fontSize: "16px",
                color: "#3b3b3b",
                fontWeight: "400",
              }}
              defaultValue={isTaxNotApplicable ? "" : taxValue}
            />

            {/* Checkbox */}
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <input
                type="checkbox"
                id="taxNotApplicable"
                checked={isTaxNotApplicable}
                onChange={(e) => setIsTaxNotApplicable(e.target.checked)}
                style={{ width: "16px", height: "16px", cursor: "pointer" }}
              />

              <label htmlFor="taxNotApplicable" style={{ cursor: "pointer" }}>
                <span
                  style={{
                    color: "#1f1f1f",
                    fontSize: "15px",
                    // opacity: 0.8,
                    display: "inline-block",
                  }}
                >
                  Tax will not be applicable on my service
                </span>
              </label>
            </div>

            <div
              style={{
                display: "flex",
                flexDirection: "row-reverse",
                gap: "15px",
              }}
            >
              <Button
                type={isTaxNotApplicable ? "button" : "submit"}
                text="Update"
                style={{ width: "110px", height: "40px", fontSize: "16px" }}
                onClick={() => {
                  if (isTaxNotApplicable) {
                    // Form validation bypass karke directly call karo
                    EditTax({
                      tax: 0,
                      is_tax_applicable: false,
                      id: dsp.id,
                    });
                  } else {
                    onSubmit();
                  }
                }}
              />
              <Button
                type={"button"}
                onClick={onClose}
                text={"Cancel"}
                isBtnNotActive={true}
                style={{ width: "110px", height: "40px", fontSize: "16px" }}
              />
            </div>
          </>
        )}
      </Form>
    </Modal>
  );
};

export default EditTaxPercentage;
